import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { savePDF } from '@progress/kendo-react-pdf';
import { useTranslation } from 'react-i18next';
import { Col, Container, Row, Card, Button, CardBody, CardTitle } from 'reactstrap';
import Notification from 'rc-notification';
import * as XLSX from 'xlsx';
import SmallLoader from '../../../../shared/components/SmallLoader';
import ResizableDataTable from '../../../Tables/ResizableTable/components/ResizableReactTable';
import { getVirtualBundleSalesDetailData, handleLoader } 
from '../../../../redux/actions/VirtualBundleSalesUploadDetailsAction';
import { tableHeaderDataVirtualBundleSales as tableHeaderData } from "../../helper";
import history from '../../../App/History';

export const setCurrencyFormat = value => value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');

const VirtualBundleSalesUploadDetails = ({ dispatch }) => {
  const { t } = useTranslation('common');
  const location = useLocation();
  const navigate = useNavigate();

  const [virtualBundleSalesDetaildata, setData] = useState([]);
  const [setModel] = useState(false);
  const { virtualBundleSalesDetailData, isLoading, salesChannelFilterData } = useSelector(
    ({ virtualBundleSalesUploadDetailsReducer, marketPlaceReducer }) =>
    ({
      virtualBundleSalesDetailData: virtualBundleSalesUploadDetailsReducer.virtualBundleSalesDetailData, 
      isLoading: virtualBundleSalesUploadDetailsReducer.isLoading,
      salesChannelFilterData: marketPlaceReducer.salesChannel
    }),
  );
  
  // Excel export function using xlsx
  const exportToExcel = () => {
    try {
      // Show loading notification
      Notification.newInstance({}, (notification) => {
        notification.notice({
          content: 'Preparing Excel file...',
          duration: 3,
          style: {top: 120, fontWeight: "bold"},
          maxCount: 10
        });
      });

      // Prepare data for export
      const exportData = virtualBundleSalesDetaildata.map(item => ({
        DATE: item.date || '',
        BUNDLE_ASIN: item.asin || '',
        TITLE: item.title || '',
        BUNDLES_SOLD: item.soldQuantity || '',
        TOTAL_SALES: item.amount || ''
      }));

      // Create workbook and worksheet
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(exportData);

      // Set column widths for better formatting
      const columnWidths = [
        { wch: 12 }, // DATE
        { wch: 15 }, // BUNDLE_ASIN
        { wch: 50 }, // TITLE
        { wch: 15 }, // BUNDLES_SOLD
        { wch: 15 }, // TOTAL_SALES
      ];
      worksheet['!cols'] = columnWidths;

      // Add worksheet to workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Virtual Bundle Sales');

      // Generate filename with current date
      const currentDate = new Date().toISOString().split('T')[0];
      const filename = `Virtual_Bundle_Sales_${currentDate}.xlsx`;

      // Save the file
      XLSX.writeFile(workbook, filename);

      // Show success notification
      Notification.newInstance({}, (notification) => {
        notification.notice({
          content: 'Excel file downloaded successfully!',
          duration: 3,
          style: {top: 120, fontWeight: "bold", color: 'green'},
          maxCount: 10
        });
      });

    } catch (error) {
      console.error('Error exporting to Excel:', error);
      Notification.newInstance({}, (notification) => {
        notification.notice({
          content: 'Error exporting to Excel. Please try again.',
          duration: 5,
          style: {top: 120, fontWeight: "bold", color: 'red'},
          maxCount: 10
        });
      });
    }
  };
  
  // implement PDF generator //
  const container = React.useRef(null)
  const exportToPDF = () => {
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'PDF loading......',
        duration: 5,
        style: {top: 120, fontWeight: "bold"},
        maxCount: 10
      });
    });
     const btnUploadExcel = document.getElementById('btnUploadExcel');
     const dvDownload = document.getElementById('dvDownload');
     btnUploadExcel.style.display = "none";  
     dvDownload.style.display = "none";   
    const element = container.current || document.body;
    savePDF(element, {
      paperSize: "auto",
      Header: "test",
      margin: 5,
      fileName: `Virtual_Bundle_Sales_Report_${new Date().getFullYear()}`,
    })
    btnUploadExcel.style.display = "block"; 
    dvDownload.style.display = "block"; 
  }

  useEffect(() => {
    const bodyData = [];    
    dispatch(getVirtualBundleSalesDetailData());
  }, []);

  useEffect(() => {
    setData(virtualBundleSalesDetailData && virtualBundleSalesDetailData.modal 
      && virtualBundleSalesDetailData.modal.data || []);
  }, [virtualBundleSalesDetailData]);

  useEffect(() => {
    const OptChennel = 'salesChannel';
    if (salesChannelFilterData && salesChannelFilterData.length > 0) {
      if (
        virtualBundleSalesDetailData?.modal?.data?.length > 0
      ) {
        setData(
          virtualBundleSalesDetailData.modal.data.filter(
            x =>
              salesChannelFilterData?.length > 0 &&
              salesChannelFilterData?.find(y => (y?.value?.toString() || '')?.toLowerCase()
                === x[OptChennel]?.toLowerCase()),
          ),
        );
      }
    } else {
      setData(virtualBundleSalesDetailData && 
        virtualBundleSalesDetailData.modal && virtualBundleSalesDetailData.modal.data || []);
    }
  }, [virtualBundleSalesDetailData, salesChannelFilterData])

  const openModel = () => {
    setModel(true);
  };  

  const uploadExcel = () => {
    navigate('/virtualbundlesales/upload');
  }

  return (
    <Container>
      <Card className="pb-3">
        <CardBody className="dashboard__card-widget card-shadow p-3">
          <CardTitle className="bold-text text-center" tag="h3">
            Virtual Bundle Sales
          </CardTitle>
        </CardBody>
      </Card>
      
      <CardBody className="p-2">
        <Row className="product-table-wrap">  
          <Col md='1'>
            <Button 
              id='btnUploadExcel' 
              className="btn btn-sm btn-primary" 
              style={{marginTop: 22, marginLeft: 15, color: 'white'}} 
              title='Upload excel' 
              onClick={uploadExcel}
            >
              Upload
            </Button>
          </Col>   
          
          <Col md='2'>
            <button 
              className="btn btn-sm btn-primary apply-date-button" 
              type="button" 
              style={{marginTop: 22, marginLeft: 15}} 
              title='Export to pdf' 
              disabled={isLoading} 
              onClick={exportToPDF}
            >
              Export pdf
            </button>
          </Col> 
          
          <Col md='9' className='text-right'>
            <div className="ExcelTable" id='dvDownload'>
              <Button
                className="btn btn-primary btn-sm download"
                onClick={exportToExcel}
                disabled={isLoading || virtualBundleSalesDetaildata.length === 0}
                style={{marginTop: 22}}
                title="Download Excel file"
              >
                <span className="action-title">Download Excel</span>
              </Button>
            </div> 
          </Col>
        </Row>  
        
        <div ref={container}>
          <Row>
            <Col md='12'>       
              {isLoading ? 
                <div style={{ minHeight: '200px' }} className="row align-items-center justify-content-center">
                  <SmallLoader loading={isLoading} />
                </div>
                :            
                <ResizableDataTable
                  reactTableData={{tableHeaderData}}
                  data={virtualBundleSalesDetaildata}
                />
              }
            </Col>
          </Row>
        </div>
      </CardBody>
    </Container>
  );
};

VirtualBundleSalesUploadDetails.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

export default connect()(VirtualBundleSalesUploadDetails);